import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterText>
        Website created by{" "}
        <FooterLink href="https://www.mxdev.tech" target="_blank" rel="noopener noreferrer">
          mxdev Tech
        </FooterLink>
         &nbsp; @2024
      </FooterText>
    </FooterContainer>
  );
};

// Styled Components
const FooterContainer = styled.footer`
  background-color: #003366;
  color: #f3f6fb;
  text-align: center;
  padding: 20px 0;
  position: relative;
  width: 100%;
  bottom: 0;
`;

const FooterText = styled.p`
  font-size: 1rem;
  margin: 0;
`;

const FooterLink = styled.a`
  color: #ffa500;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

export default Footer;
